import { PrintResult } from './printing.types';

const pendingJobs = new Map<string, Promise<PrintResult>>();

export const printRequestKey = (documentType: string, documentId: number) =>
  `${documentType}:${documentId}`;

export const executePrintOnce = (
  key: string,
  operation: () => Promise<PrintResult>
): Promise<PrintResult> => {
  const pending = pendingJobs.get(key);
  if (pending) return pending;

  const promise = operation().finally(() => pendingJobs.delete(key));
  pendingJobs.set(key, promise);
  return promise;
};

export const isPrintPending = (key: string): boolean => pendingJobs.has(key);
